/** @module Enums */ /** typedoc */
/**
 * State Enum for indivial Service Providers (DSP)
 * Exemple : Youtube / Amazon ...
 */
export enum ServiceProviderStateEnum {
    PendingRelease = 'PendingRelease',
    Released = 'Released',
    Failed = 'Failed',
    PendingTakeDown = 'PendingTakeDown',
    TakenDown = 'TakenDown',
    Live = 'Live',
}
